/**
 * Z-index scale — single source of truth (DESIGN-SYSTEM §2.4).
 *
 * Replaces scattered hardcoded values (FAB z-30, backdrop z-40, drawer z-50,
 * toast z-[60], confirm z-[70]). Use these constants as inline `style={{ zIndex }}`
 * or via the matching Tailwind `z-*` utilities where they exist.
 */

export const zBase = 0; // page content
export const zSticky = 10; // sticky table headers, bulk action bar
export const zOverlay = 40; // modal / drawer backdrop
export const zModal = 50; // modal & drawer surface
// Poppers (select / dropdown-menu / popover / tooltip) MUST sit above modal
// surfaces — they're routinely opened INSIDE dialogs/drawers, and at z < zModal
// the menu renders behind the modal (invisible + unclickable). Kept below the
// toast/command layers.
export const zDropdown = 55;
export const zToast = 60; // toast stack (sonner)
export const zCommand = 70; // command palette (above all)
